__turbopack_context__.v({
  "modal-button": "modal-printer-dynamic-comparison-visid-module-scss-module__J312rG__modal-button",
  "modalAction": "modal-printer-dynamic-comparison-visid-module-scss-module__J312rG__modalAction",
  "modalText": "modal-printer-dynamic-comparison-visid-module-scss-module__J312rG__modalText",
});
